const ROW_STYLE = Object.freeze({
  COMING_SOON: 'coming-soon',
  HIGHLIGHTED: 'highlighted',
  REGULAR: 'regular',
});

const SUBTOTAL = Object.freeze({
  COMMUNITY: 10000000,
  FUNDS: 25000000,
  LIQUIDITY_POOL: 15000000,
  VALIDATOR: 10000000,
});

export default Object.freeze({
  ROW_STYLE,
  SUBTOTAL,
});
